import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { CircularProgress, Box } from '@mui/material';

const ProtectedMemberRoute = ({ children }) => {
    const { user } = useAuth();
    
    // Add loading state while we wait for user data
    if (!user) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
                <CircularProgress />
            </Box>
        );
    }

    const hasActiveMembership = user?.membershipNumber && 
                               user?.membershipType;

    if (!hasActiveMembership) {
        return <Navigate to="/dashboard" replace />;
    }

    return children;
};

export default ProtectedMemberRoute; 